import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { ModalFooter } from 'reactstrap'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { CloseFooter } from '@/dialogs/common/closeFooter'
import { modes } from '@/components/changeRequests/propertyRenderer'
import { FormContext } from '@/components/changeRequests/formContext'
import { actionCreators } from '@/store/Forms'
import keys from 'lodash/keys'
import { ValidationState } from '@/components/validation'

export const ChangeItemDialogFooter = (props) => {
  const { onAction, isOriginal, readonly } = props
  const ctx = useContext(FormContext)

  if (ctx.mode === modes.edit && !readonly) {
    return (
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} disabled={!isValid}
          onAction={onAction} />
      } />
    )
  } else if (ctx.mode === modes.approval && !isOriginal && !readonly) {
    return <ApprovalFooter {...props} />
  }
  return <CloseFooter {...props} />
}

function mapStateToProps (state, ownProps) {
  const data = state.forms.getIn(['data', ownProps.parentUid])
  let approvalData = data.get('approvalInfo')
  approvalData = approvalData ? approvalData.toJS() : {}
  let approved
  const approvalKeys = keys(approvalData)
  for (let i = 0; i < approvalKeys.length; i++) {
    const key = approvalKeys[i]
    if (!key.startsWith(ownProps.target)) continue
    let a = approvalData[key]
    if (typeof approved !== 'undefined' && approved !== a) {
      approved = undefined
      break
    }
    approved = a
  }
  return {
    ...ownProps,
    approving: data.get('savingApproval'),
    approved
  }
}

const mapDispatchToProps = {
  onApprovalChange: actionCreators.changeApproval
}

@connect(mapStateToProps, mapDispatchToProps)
class ApprovalFooter extends React.Component {
  render () {
    const { uid, approved, approving, closeDialog, onApprovalChange, target, value } = this.props
    return (
      <ModalFooter>
        <Button color='success' onClick={() => onApprovalChange(uid, target, true, value)} disabled={approving || approved || false}>
          <span><Resx name={value.__isCreated || value.isDeleted ? 'Common.Approve' : 'Common.ApproveAll'} /></span>
        </Button>
        <Button color='danger' onClick={() => onApprovalChange(uid, target, false, value)} disabled={approving || approved === false || false}>
          <span><Resx name={value.__isCreated || value.isDeleted ? 'Common.Reject' : 'Common.RejectAll'} /></span>
        </Button>
        <Button onClick={() => closeDialog()}>
          <Resx name='Common.Cancel' />
        </Button>
      </ModalFooter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/dialogs/common/changeItemDialogFooter.js